export default __webpack_public_path__ + "static/media/logo_white_transparent.7026f7cb.png";